import { inject, injectable } from "@launchtray/tsyringe-async";
import { Bindable, NotifyProperty, nameof } from "../../../../../shared/bindable-data";
import { INetworkClient } from "../../../../networking/INetworkClient";
import { IShopModel } from "./IShopModel";
import { ShopItem } from "./ShopItem";

@injectable()
export class ShopModel extends Bindable implements IShopModel {
    public readonly shopItems: NotifyProperty<ShopItem[]>;

    private readonly networkClient: INetworkClient;

    public constructor(@inject("INetworkClient") networkClient: INetworkClient) {
        super();
        this.networkClient = networkClient;
        this.shopItems = new NotifyProperty<ShopItem[]>(this, nameof(this, "shopItems"), new Array<ShopItem>());
    }

    public async getShopItems(): Promise<void> {
        const shopItemsDto = await this.networkClient.getShopItems();
        if (shopItemsDto.items == undefined) {
            throw new Error("Failed to load shop items.");
        }
        const shopItems = shopItemsDto.items.map(item => new ShopItem(item));
        this.shopItems.setValue(shopItems);
    }
}
